import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getInventoryAccessories,
  getInventoryAccessory,
  createInventoryAccessory,
  updateInventoryAccessory,
  deleteInventoryAccessory,
} from "api/inventoryAccessoryApi"

export const INVENTORY_ACCESSORY_QUERY_KEY = "inventory-accessories"

export const useInventoryAccessories = (params = {}, enabled = true) =>
  usePaginatedResource(
    INVENTORY_ACCESSORY_QUERY_KEY,
    getInventoryAccessories,
    params,
    enabled
  )

export const useInventoryAccessory = (id, enabled = true) =>
  useResourceItem(
    INVENTORY_ACCESSORY_QUERY_KEY,
    getInventoryAccessory,
    id,
    enabled
  )

export const useCreateInventoryAccessory = () =>
  useCreateResource(createInventoryAccessory, INVENTORY_ACCESSORY_QUERY_KEY)

export const useEditInventoryAccessory = () =>
  useEditResource(updateInventoryAccessory, INVENTORY_ACCESSORY_QUERY_KEY)

export const useDeleteInventoryAccessory = () =>
  useDeleteResource(deleteInventoryAccessory, INVENTORY_ACCESSORY_QUERY_KEY)
